import { render, staticRenderFns } from "./selectForYou.vue?vue&type=template&id=5ab3b1a3&scoped=true"
import script from "./selectForYou.vue?vue&type=script&lang=js"
export * from "./selectForYou.vue?vue&type=script&lang=js"
import style0 from "./selectForYou.vue?vue&type=style&index=0&id=5ab3b1a3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab3b1a3",
  null
  
)

export default component.exports